import { useState, useContext } from "react";
import {
  Form,
  RadioButtonContainer,
} from "../../../../../../layout/FormLayout";
import { useFormWrapper } from "../../../../../../util/util";
import { Notifications } from "../../../../../../components/Notifications/NotificationsContext";
import { SaveButtonPrimaryMedium } from "../../shared";
import { useTranslation } from "react-i18next";
import { RadioButtonWithController } from "../../../../../../components/RadioButton/RadioButton";
import { Controller } from "react-hook-form";
import { useStoreState } from "../../../../../../util/util";
import axios from "axios";

interface FormValues {
  mandatory_registration_message: boolean;
}

export const EditRegistrationFormSettings = ({
  closeEditRegistrationFormSettings,
  mandatoryRegistrationMessage,
  onSave,
}: {
  closeEditRegistrationFormSettings: () => void;
  mandatoryRegistrationMessage: boolean;
  onSave?: (data: any) => void;
}) => {
  const { notifySuccess, notifyError } = useContext(Notifications);
  const { storefront_id } = useStoreState();
  const [submitting, setSubmitting] = useState(false);
  const { t } = useTranslation();

  const { handleSubmit, control, setValue } = useFormWrapper<FormValues>({
    defaultValues: {
      mandatory_registration_message: mandatoryRegistrationMessage,
    },
  });

  const onSubmit = async (formValues: FormValues) => {
    setSubmitting(true);
    try {
      const response = await axios.patch(
        `/v1/storefronts/${storefront_id}/metadata`,
        {
          mandatory_registration_message:
            formValues.mandatory_registration_message,
        }
      );

      if (response.data && onSave) {
        onSave(response.data);
      }

      notifySuccess(t("Registration form settings updated"));
      setSubmitting(false);
      closeEditRegistrationFormSettings();
    } catch (error) {
      notifyError(t("There was an error saving the changes"), { error });
      setSubmitting(false);
    }
  };

  return (
    <Form noValidate onSubmit={handleSubmit(onSubmit)}>
      <RadioButtonContainer style={{ marginTop: "15px" }}>
        <Controller
          control={control}
          name="mandatory_registration_message"
          render={({ onChange, value, ...props }) => (
            <RadioButtonWithController
              {...props}
              checked={value === true}
              onChange={(e) => {
                onChange(true);
                setValue("mandatory_registration_message", true);
              }}
              value="true"
              optionTitle={t("Mandatory")}
            />
          )}
        />
        <Controller
          control={control}
          name="mandatory_registration_message"
          render={({ onChange, value, ...props }) => (
            <RadioButtonWithController
              {...props}
              checked={value === false}
              onChange={(e) => {
                onChange(false);
                setValue("mandatory_registration_message", false);
              }}
              value="false"
              optionTitle={t("Optional")}
            />
          )}
        />
      </RadioButtonContainer>
      <SaveButtonPrimaryMedium loading={submitting}>
        {t("Save your changes")}
      </SaveButtonPrimaryMedium>
    </Form>
  );
};
